import { GetListParams } from 'react-admin';
import { registerModuleDataProvider, CustomDataProvider } from '../../providers/CustomDataProvider';
import { Resources } from '../resource';
import { apiGet, apiSend } from '../perps-v1-shared/api';
import { MarketSector } from '../perps-v1-shared/types';

// getList -> GET /perps-v1/sectors；其余动作走 api.ts 直连
export class PerpsV1SectorsDataProvider implements CustomDataProvider {
  // eslint-disable-next-line class-methods-use-this
  async getList(resource: string, _params: GetListParams): Promise<any> {
    if (resource !== Resources.perpsV1Sectors) {
      return Promise.reject(new Error('Unsupported getList resource'));
    }
    const json = await apiGet<{ data: MarketSector[]; total: number }>('/perps-v1/sectors');
    return { data: json?.data ?? [], total: json?.total ?? 0 };
  }
}

export const perpsV1SectorsDataProvider = new PerpsV1SectorsDataProvider();

export const sectorsApi = {
  create: (body: unknown) => apiSend<MarketSector>('/perps-v1/sectors', 'POST', body),
  update: (code: string, body: unknown) => apiSend<MarketSector>(`/perps-v1/sectors/${code}`, 'PUT', body),
  setEnabled: (code: string, enabled: boolean) =>
    apiSend<MarketSector>(`/perps-v1/sectors/${code}/enabled`, 'PUT', { enabled }),
  remove: (code: string) => apiSend<{ deleted: boolean }>(`/perps-v1/sectors/${code}`, 'DELETE'),
};
